/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ooL7EhXDmFQWnW9sxtchhE
// Component: AqMe9uK-Yh

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  StrictProps,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import Button from "../../components/widgets/Button"; // plasmic-import: SEF-sRmSoqV5c/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "../PP__plasmickit_dashboard.css"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectcss
import sty from "./PlasmicFreeTrialModal.module.css"; // plasmic-import: AqMe9uK-Yh/css

import MarkFullColorIcon from "../plasmic_kit_design_system/PlasmicIcon__MarkFullColor"; // plasmic-import: l_n_OBLJg/icon
import ArrowRightSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ArrowRightSvg"; // plasmic-import: 9Jv8jb253/icon
import ChevronDownSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ChevronDownSvg"; // plasmic-import: xZrB9_0ir/icon

createPlasmicElementProxy;

export type PlasmicFreeTrialModal__VariantMembers = {};
export type PlasmicFreeTrialModal__VariantsArgs = {};
type VariantPropType = keyof PlasmicFreeTrialModal__VariantsArgs;
export const PlasmicFreeTrialModal__VariantProps = new Array<VariantPropType>();

export type PlasmicFreeTrialModal__ArgsType = { trialDays?: number };
type ArgPropType = keyof PlasmicFreeTrialModal__ArgsType;
export const PlasmicFreeTrialModal__ArgProps = new Array<ArgPropType>(
  "trialDays"
);

export type PlasmicFreeTrialModal__OverridesType = {
  root?: Flex__<"div">;
  h3?: Flex__<"h3">;
  text?: Flex__<"div">;
  freeBox?: Flex__<"div">;
  confirmButton?: Flex__<typeof Button>;
};

export interface DefaultFreeTrialModalProps {
  trialDays?: number;
  className?: string;
}

const $$ = {};

function PlasmicFreeTrialModal__RenderFunc(props: {
  variants: PlasmicFreeTrialModal__VariantsArgs;
  args: PlasmicFreeTrialModal__ArgsType;
  overrides: PlasmicFreeTrialModal__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          trialDays: 15,
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_ooL7EhXDmFQWnW9sxtchhE",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      <MarkFullColorIcon
        className={classNames("all", sty.svg__er1Mj)}
        role={"img"}
      />

      <h3
        data-plasmic-name={"h3"}
        data-plasmic-override={overrides.h3}
        className={classNames("all", "h3", "h3__ooL7E", "__wab_text", sty.h3)}
      >
        <React.Fragment>{`Discover all of Plasmic with a ${$props.trialDays}-day trial of Scale`}</React.Fragment>
      </h3>
      <div
        data-plasmic-name={"text"}
        data-plasmic-override={overrides.text}
        className={classNames("all", "__wab_text", sty.text)}
      >
        <React.Fragment>{`We\u2019ve upgraded you to a free ${$props.trialDays}-day trial of the Scale plan. Experience Plasmic's full range of features to choose the best plan for you.\n\nWhen your trial ends, we'll automatically move your account to the Free plan unless you choose to upgrade.`}</React.Fragment>
      </div>
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames("all", sty.freeBox)}
      >
        <Button
          data-plasmic-name={"confirmButton"}
          data-plasmic-override={overrides.confirmButton}
          className={classNames("__wab_instance", sty.confirmButton)}
          endIcon={
            <ChevronDownSvgIcon
              className={classNames("all", sty.svg__akfXw)}
              role={"img"}
            />
          }
          startIcon={
            <ArrowRightSvgIcon
              className={classNames("all", sty.svg__u5Zd2)}
              role={"img"}
            />
          }
          type={["primary"]}
        >
          {"Continue"}
        </Button>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "h3", "text", "freeBox", "confirmButton"],
  h3: ["h3"],
  text: ["text"],
  freeBox: ["freeBox", "confirmButton"],
  confirmButton: ["confirmButton"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  h3: "h3";
  text: "div";
  freeBox: "div";
  confirmButton: typeof Button;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicFreeTrialModal__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicFreeTrialModal__VariantsArgs;
    args?: PlasmicFreeTrialModal__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicFreeTrialModal__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicFreeTrialModal__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicFreeTrialModal__ArgProps,
          internalVariantPropNames: PlasmicFreeTrialModal__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicFreeTrialModal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicFreeTrialModal";
  } else {
    func.displayName = `PlasmicFreeTrialModal.${nodeName}`;
  }
  return func;
}

export const PlasmicFreeTrialModal = Object.assign(
  // Top-level PlasmicFreeTrialModal renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    h3: makeNodeComponent("h3"),
    text: makeNodeComponent("text"),
    freeBox: makeNodeComponent("freeBox"),
    confirmButton: makeNodeComponent("confirmButton"),

    // Metadata about props expected for PlasmicFreeTrialModal
    internalVariantProps: PlasmicFreeTrialModal__VariantProps,
    internalArgProps: PlasmicFreeTrialModal__ArgProps,
  }
);

export default PlasmicFreeTrialModal;
/* prettier-ignore-end */
